// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.adc-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid #bbf7d0;
  background: #f0fdf4;
  border-radius: 12px;
}

.adc-checkmark {
  width: 26px;
  height: 26px;
  border-radius: 999px;
  background: #16a34a;
}
.applied-discount-wrapper {
  background-color: #f9fafb;
  display: flex;
  align-items: center;
  justify-content: center;
}

.applied-discount-inner-wrapper {
  width: 100%;
}

.applied-discount-box {
  border: 2px dashed #16a34a;
  border-radius: 8px;
  padding: 8px;
  background-color: #f0fdf4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.applied-discount-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.applied-discount-checkmark {
  width: 24px;
  height: 24px;
  background-color: #16a34a;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.adc-copy {
  min-width: 0;
  flex: 1;
}

.adc-title {
  color: #166534;
  font-size: 13px;
  font-weight: 700;
}

.adc-value {
  color: #166534;
  font-size: 12px;
  font-weight: 600;
  margin-top: 2px;
}
.applied-discount-text {
  font-size: 12px;
  font-weight: 500;
  color: #374151;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/DiscountDrawer/AppliedDiscountCard.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":["\n.adc-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n  border: 1px solid #bbf7d0;\n  background: #f0fdf4;\n  border-radius: 12px;\n}\n\n.adc-checkmark {\n  width: 26px;\n  height: 26px;\n  border-radius: 999px;\n  background: #16a34a;\n}\n.applied-discount-wrapper {\n  background-color: #f9fafb;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.applied-discount-inner-wrapper {\n  width: 100%;\n}\n\n.applied-discount-box {\n  border: 2px dashed #16a34a;\n  border-radius: 8px;\n  padding: 8px;\n  background-color: #f0fdf4;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.applied-discount-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.applied-discount-checkmark {\n  width: 24px;\n  height: 24px;\n  background-color: #16a34a;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.adc-copy {\n  min-width: 0;\n  flex: 1;\n}\n\n.adc-title {\n  color: #166534;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.adc-value {\n  color: #166534;\n  font-size: 12px;\n  font-weight: 600;\n  margin-top: 2px;\n}\n.applied-discount-text {\n  font-size: 12px;\n  font-weight: 500;\n  color: #374151;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
